import { DisplayableContentType, MyopiaRefractionContent } from '../model/model'
import { mapConnectTrendsOverTimeZoomData } from './mapConnectTrendsOverTimeZoomData'

/**
 *
 * @param section displayable content section
 * @param content content received from CONNECT application; this will follow CONNECT standard/format, so it must be transformed to match the expected format in the application
 * @returns
 */
export const transformToDisplayableContent = (
	section: DisplayableContentType,
	content: any,
) => {
	switch (section) {
		case 'myopia-refraction':
			return {
				section,
				content: {
					day: {
						default: {
							eyes: content.dayStandard,
						},
					},
				},
			} as MyopiaRefractionContent

		case 'clinical-content-summary':
			return {
				section,
				content,
			}

		case 'trends-over-time-zoom':
			return mapConnectTrendsOverTimeZoomData(content)

		default:
			return content
	}
}
